"use strict";

PF.FileInput = class FileInput extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {
				element: undefined,
			},
			multiple: false,
			accept: '*',
			previewTypes: [],
		};
		}

	init()
		{
		super.init();
		this.dom.element.bindAttributes();
		this.calc('dom.element.attributes.accept', 'accept');
		this.calc('dom.element.attributes.multiple', 'multiple');
		if (window.buildName !== 'ios')
			{
			this.dom.element.attributes.capture = 'environment';
			}
		this.dom.element.on('change', () => this.fileChanged());
		}

	fileChanged()
		{
		let filesInfo = this.dom.element.node.files;
		let names = [];
		for (let i = 0; i < filesInfo.length; i++)
			{
			names.push(filesInfo[i].name);
			}
		this.value = names.join(', ');


		let files = [];
		this.fileLoadedStatus = {};
		for (let i = 0; i < filesInfo.length; i++)
			{
			let file = new PF.Model.File({
				previewTypes: this.previewTypes
			});
			this.fileLoadedStatus[i] = false;
			file.on('file-readed', () => this.fileLoadedSlot(file, i));
			file.byInfo(filesInfo[i]);
			files.push(file);
			}
		this.files = files;
		if (files.length === 1 && this.multiple === false)
			{
			this.file = files[0];
			}
		}

	fileLoadedSlot(file, index)
		{
		this.fileLoadedStatus[index] = true;
		let allLoaded = true;
		for (let i = 0; i < this.files.length; i++)
			{
			if (this.fileLoadedStatus[i] === false)
				{
				allLoaded = false;
				}
			}
		if (allLoaded === true)
			{
			this.trigger('files-readed');
			}
		}
	};


